import React from "react";
import { useDispatch } from "react-redux";
import * as siteMaster from "~/data/actions/siteActions";
import i18n from '~/i18n'
import LinkChecker from "./linkChecker";

const CheckLinksButton = ({ templateId, onClick, ...rest }) => {
  const dispatch = useDispatch();

  const drawerContent = <LinkChecker templateId={templateId} />;

  async function checkLinks() {
    if (onClick && typeof (onClick === "function")) {
      await onClick();
    }

    dispatch(
      siteMaster.alterSiteDrawer(
        true,
        true,
        "right",
        drawerContent,
        true,
        "500px"
      )
    );
  }

  return (
    <li data-ph="dragdrop-check-links" onClick={checkLinks} {...rest}>
      {i18n.t('templates:add.drag.checkLinks')}
    </li>
  );
};

export default CheckLinksButton;
